<lib-card class="hcCard" *ngIf="healthCenter; else noHealthCenterTemplate">
  <div class="left">
    <lib-icon class="icon mb-2" [type]="'people'" [ngClass]="queueStatus"></lib-icon>
    <span class="counter">{{ peopleInQueueCount }}</span>
    <span class="counter-label text-color-muted m-0">{{ "session.people-in-queue" | translate }}</span>
  </div>
  <div>
    <p class="hcCard__description">{{ healthCenter.health_center_name }}</p>
    <ng-container *ngIf="queueDelay$ | async as delay">
      <span class="queue-delay queue-delay--normalized" *ngIf="delay.type === 'normalized'">
        {{ "session.queue-normalized" | translate }}
      </span>
      <span class="queue-delay queue-delay--delayed" *ngIf="delay.type === 'delayed'">
        {{
          (delay.hours === 1 ? "session.queue-delay-hour" : "session.queue-delay-hours")
            | translate: { hours: delay.hours }
        }}
      </span>
    </ng-container>
  </div>
  <div>
    <button
      libButton
      (click)="impersonate(healthCenter.health_center_id)"
      [disabled]="disabled || inUseHc(healthCenter.health_center_id, hcService.currentHcId$ | async)"
    >
      {{ getButtonText(healthCenter.health_center_id, hcService.currentHcId$ | async) }}
    </button>
  </div>
</lib-card>
<ng-template #noHealthCenterTemplate>
  <lib-card class="card">
    <div class="left">
      <lib-icon class="icon mb-2" [type]="'people'" [ngClass]="queueStatus"></lib-icon>
      <span class="counter">{{ peopleInQueueCount }}</span>
      <span class="counter-label text-color-muted m-0">{{ "session.people-in-queue" | translate }}</span>
      <ng-container *ngIf="queueDelay$ | async as delay">
        <span class="queue-delay queue-delay--normalized" *ngIf="delay.type === 'normalized'">
          {{ "session.queue-normalized" | translate }}
        </span>
        <span class="queue-delay queue-delay--delayed" *ngIf="delay.type === 'delayed'">
          {{
            (delay.hours === 1 ? "session.queue-delay-hour" : "session.queue-delay-hours")
              | translate: { hours: delay.hours }
          }}
        </span>
      </ng-container>
    </div>
    <div class="right">
      <p class="description text-color-muted">
        <ng-content></ng-content>
      </p>
    </div>
  </lib-card>
</ng-template>
